import { HOME_BODY_COLOR } from "styles/oneOffColor";

const styles = {
  active: {
    fontSize: { xs: 12, md: 15 },
    borderRadius: 30,
    backgroundColor: "black",
    color: "white",
    textTransform: "none",
    "&:hover": {
      color: "black",
      border: "1px solid",
      backgroundColor: "yellow.main",
    },
    px: 2,
  },
  inactive: {
    fontSize: { xs: 12, md: 15 },
    borderRadius: 30,
    color: "black",
    textTransform: "none",
    px: 2,
    backgroundColor: { xs: "white", md: HOME_BODY_COLOR },
  },
};

export default styles;
